// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryListStyles } from "@rpsc/Overrides/Widgets/Category/CategoryList";
import IconPlus from "@rpsc/XDL/Icons/IconPlus";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.wrapper = {
    css: css`
        display: flex;
        gap: 22px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            justify-content: center;
        }
    `,
};

categoryListStyles.cardContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex-basis: 204px;
    `,
};

categoryListStyles.viewMoreLink = {
    ...createLinkIconStyles(
        IconPlus,
        {
            typographyProps: {
                size: 12,
                lineHeight: "14px",
                weight: fontConfig.weight.bold,
            },
            icon: { iconProps: { size: 9 } },
        },
    ),
};
